import React, { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";

import CustomLink from "../other/CustomLink";
import AppText from "../other/AppText";
import { cn } from "@/lib/utils";
import { ESG_URL_MAPPING_TO_LABEL } from "../other/constants";
import { Transition } from "@headlessui/react";

interface IESGMobileMenu {
  dict: { [key: string]: string };
  isHidden: boolean;
  pathname: string;
  isLargeScreen: boolean;
}

const ESGMobileMenu = ({ dict, pathname, isHidden, isLargeScreen }: IESGMobileMenu) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (isLargeScreen) {
      setOpen(false);
    }
  }, [isLargeScreen]);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const mainButtonLabel = () => {
    if (pathname.endsWith("/about-us/sustainability-impact")) {
      return dict.deliveringOpportunity;
    }

    const activeUrl = ESG_URL_MAPPING_TO_LABEL.find((item) => pathname.includes(item.url));

    if (activeUrl) {
      return dict[activeUrl.name];
    } else return "N/A";
  };

  const handleBtnClick = () => {
    setOpen((prev) => !prev);
  };

  return (
    <>
      <div
        className={cn(
          "lg:hidden esgMobileMenu z-10 relative bg-black-5",
          isHidden && "hidden",
          !pathname.includes("/about-us/sustainability-impact") && "hidden"
        )}
      >
        <div
          className={`h-[56px] bg-black-5 w-full 
        overflow-hidden border-b-[1px] border-black-20`}
        >
          <button
            onClick={handleBtnClick}
            className={`outline-none focus-within:outline-dijon whitespace-nowrap text-ellipsis 
          flex justify-between items-center p-4 overflow-hidden w-full h-full`}
          >
            <span className="text-ellipsis w-full overflow-hidden font-semibold text-left">{mainButtonLabel()}</span>

            <ChevronDown size={20} className={cn("transition", open && "rotate-180")} aria-label="chevron down icon" />
          </button>
        </div>

        <Transition
          show={open}
          enter="transition-all ease-out duration-100"
          enterFrom="opacity-0 scale-90 "
          enterTo="opacity-100 scale-100 "
          leave="transition-all ease-out duration-200"
          leaveFrom="opacity-100 scale-100 "
          leaveTo="opacity-0 scale-90 "
        >
          <div className="bg-black-5 fixed w-full h-screen p-4">
            <CustomLink href="/about-us/sustainability-impact">
              <AppText
                type="BODY_SMALL"
                className={cn("py-2", pathname.endsWith("/about-us/sustainability-impact") && "font-semibold")}
              >
                {dict.deliveringOpportunity}
              </AppText>
            </CustomLink>
            <AppText type="BODY_SMALL" className="text-black-60 py-2">
              {dict.esgReport}
            </AppText>
            <CustomLink href="/about-us/sustainability-impact/overview">
              <AppText
                type="BODY_SMALL"
                className={cn(
                  "py-[6px] pl-6",
                  pathname.includes("/about-us/sustainability-impact/overview") && "font-semibold"
                )}
              >
                {dict.overview}
              </AppText>
            </CustomLink>
            <CustomLink href="/about-us/sustainability-impact/environmental-impact">
              <AppText
                type="BODY_SMALL"
                className={cn(
                  "py-[6px] pl-6",
                  pathname.includes("/about-us/sustainability-impact/environmental-impact") && "font-semibold"
                )}
              >
                {dict.environmentalImpact}
              </AppText>
            </CustomLink>
            <CustomLink href="/about-us/sustainability-impact/social-impact">
              <AppText
                type="BODY_SMALL"
                className={cn(
                  "py-[6px] pl-6",
                  pathname.includes("/about-us/sustainability-impact/social-impact") && "font-semibold"
                )}
              >
                {dict.socialImpact}
              </AppText>
            </CustomLink>
            <CustomLink href="/about-us/sustainability-impact/governance-impact">
              <AppText
                type="BODY_SMALL"
                className={cn(
                  "py-[6px] pl-6",
                  pathname.includes("/about-us/sustainability-impact/governance-impact") && "font-semibold"
                )}
              >
                {dict.governanceImpact}
              </AppText>
            </CustomLink>
            {/* <CustomLink href="/about-us/sustainability-impact/view-report" >
              <AppText
                type="BODY_SMALL"
                className={cn(
                  "py-[6px] pl-6",
                  pathname.includes("/about-us/sustainability-impact/view-report") && "font-semibold"
                )}
              >
                {dict.viewOurEsgReport}
              </AppText>
            </CustomLink> */}
            <CustomLink href="/about-us/sustainability-impact/employee-wellness-and-safety">
              <AppText
                type="BODY_SMALL"
                className={cn(
                  "py-2",
                  pathname.includes("/about-us/sustainability-impact/employee-wellness-and-safety") && "font-semibold"
                )}
              >
                {dict.employeeWellnessSafety}
              </AppText>
            </CustomLink>
            <CustomLink href="/about-us/sustainability-impact/community-outreach">
              <AppText
                type="BODY_SMALL"
                className={cn(
                  "py-2",
                  pathname.includes("/about-us/sustainability-impact/community-outreach") && "font-semibold"
                )}
              >
                {dict.communityOutreach}
              </AppText>
            </CustomLink>
            <CustomLink href="/about-us/sustainability-impact/sustainability">
              <AppText
                type="BODY_SMALL"
                className={cn(
                  "py-2",
                  pathname.includes("/about-us/sustainability-impact/sustainability") && "font-semibold"
                )}
              >
                {dict.sustainability}
              </AppText>
            </CustomLink>
          </div>
        </Transition>
      </div>
    </>
  );
};

export default ESGMobileMenu;
